export function DurationChoice({ name, value, onChange, className = "" }: {
  name: string;
  value: "temporary" | "permanent";
  onChange: (value: "temporary" | "permanent") => void;
  className?: string;
}) {
  return <fieldset className={`duration-choice ${className}`}>
    <legend>Access duration</legend>
    <div className="duration-options">
      <label className={value === "temporary" ? "selected" : ""}>
        <input type="radio" name={name} value="temporary" aria-label="Temporary access" aria-describedby={`${name}-temporary-hint`} checked={value === "temporary"} onChange={() => onChange("temporary")} />
        <span><strong>Temporary access</strong><small id={`${name}-temporary-hint`}>Choose when access starts and ends</small></span>
      </label>
      <label className={value === "permanent" ? "selected" : ""}>
        <input type="radio" name={name} value="permanent" aria-label="Permanent access — No expiry" aria-describedby={`${name}-permanent-hint`} checked={value === "permanent"} onChange={() => onChange("permanent")} />
        <span><strong>Permanent access — No expiry</strong><small id={`${name}-permanent-hint`}>Continues until access is removed</small></span>
      </label>
    </div>
  </fieldset>;
}
